import {getCookie, setCookie} from "cronus-theme/default/global/js/utilities/cookie";

/**
 * Promo-Modal (Kollektion promobar, DevOps #231945)
 *
 * Das Modal wird serverseitig mit `hidden` gerendert und nur angezeigt,
 * solange kein Cookie mit dem aktuellen `data-modified-date` existiert.
 * Beim Schliessen wird das modified-date als Cookie gespeichert - aendert
 * sich der Eintrag im CMS (neues modified-date), erscheint das Modal wieder.
 */
export function initPromoBarModal() {
    for (const modal of document.querySelectorAll('.promoBarModal')) {
        const modifiedDate = modal.dataset.modifiedDate || "";
        const cookieName = (modal.id || "promoBarModal") + "Closed";

        if (modifiedDate !== "" && getCookie(cookieName) === modifiedDate) {
            continue;
        }

        modal.hidden = false;

        const closeBtn = modal.querySelector('.promoBarModal__close');
        if (closeBtn) {
            closeBtn.addEventListener("click", () => {
                modal.hidden = true;
                setCookie(cookieName, modifiedDate);
            });
        }
    }
}
